import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { galleryPhotos } from '../data/gallery';
import { urls } from '../data/site';
const layoutClasses = {
  feature: {
    figure: 'md:col-span-5 md:row-span-2',
    frame: 'aspect-[4/5] md:aspect-auto'
  },
  standard: {
    figure: 'md:col-span-7',
    frame: 'aspect-[4/3] md:aspect-auto'
  }
};
export function WorkGallery() {
  return <section id="work" aria-labelledby="work-heading" className="border-t border-line bg-paper-deep py-14 md:py-28" data-id="element-244" data-mp="8esgtjze0ti2">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12" data-id="element-245" data-mp="ddc35lhw87ay">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-246" data-mp="i5daqu4499un">
          <div data-id="element-247" data-mp="n583z4bd6biv">
            <Eyebrow data-id="element-248" data-mp="n3okl4uevkcv">See the work</Eyebrow>
            <h2 id="work-heading" className="mt-5 font-display text-[40px] font-bold uppercase leading-[0.95] text-ink md:text-[56px] lg:text-[64px]" data-id="element-249" data-mp="n6j48u5lp158">
              Bodywork you can look at.
            </h2>
            <p className="mt-4 max-w-[30rem] text-[17px] leading-relaxed text-steel" data-id="element-250" data-mp="v5zwtizzvq9x">
              A few commercial vehicles from our shop gallery in Brighton.
            </p>
          </div>
          <a href={urls.gallery} target="_blank" rel="noopener noreferrer" className="group inline-flex min-h-[44px] shrink-0 items-center gap-2 self-start border-b-2 border-brand pb-1 font-display text-[18px] font-semibold uppercase tracking-[0.06em] text-ink md:self-auto" data-id="element-251" data-mp="m3gwp6nlfrrd">
            Explore Our Work
            <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-252" data-mp="19w789erl4914" />
          </a>
        </div>

        <div className="mt-12 grid gap-8 md:mt-14 md:h-[600px] md:grid-cols-12 md:grid-rows-2 md:gap-5 lg:h-[700px]" data-id="element-253" data-mp="1xjp53opphxay">
          {galleryPhotos.map(photo => {
          const l = layoutClasses[photo.layout];
          return <figure key={photo.src} className={`flex min-h-0 flex-col ${l.figure}`} data-id="element-254" data-mp="3n1cg6ggxjkm3">
                <div className={`relative overflow-hidden bg-ink md:min-h-0 md:flex-1 ${l.frame}`} data-id="element-255" data-mp="3r1mohzs72n44">
                  <img src={photo.src} alt={photo.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" style={{
                objectPosition: photo.objectPosition
              }} data-id="element-256" data-mp="3da81ziz2w3sb" />
                </div>
                <figcaption className="mt-3 flex items-center gap-3 text-[15px] text-steel" data-id="element-257" data-mp="389k3ydcfmmol">
                  <span aria-hidden="true" className="h-[2px] w-5 shrink-0 bg-brand" data-id="element-258" data-mp="2udq6cqh3zjqs" />
                  {photo.caption}
                </figcaption>
              </figure>;
        })}
        </div>
      </div>
    </section>;
}